import React from "react";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import ManagerLayout from "./components/evd-manager/Layout";
import Header from "./components/evd-manager/Header";
import AddAgent from "./components/evd-manager/add-agent";
import AgentList from "./components/evd-manager/agent-list";
import AgentDetail from "./components/evd-manager/agent-detail";
import Login from "./components/Login";
import WithPrivateRoute from "./utils/WithPrivateRoute";
import AddOrder from "./components/evd-manager/add-order";
import OrderList from "./components/evd-manager/orders-list";
import OrderDetail from "./components/evd-manager/order-detail";
import AdminLayout from "./components/admin/Layout";
import AdminHeader from "./components/admin/Header";
import Notifications from "./components/admin/notifications";
import AddSettlement from "./components/evd-manager/add-settlement";
import AddLoan from "./components/evd-manager/add-loan";
import BarChart from "./components/BarChart";
import PieChart from "./components/PieChart";
import Head from "./components/Head";
import OrderListAdmin from "./components/admin/orders-list";
import OrderDetailAdmin from "./components/admin/order-detail";
import NewChart from "./components/NewChart";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Detail from "./components/admin/notifications/Detail";
import AgentDetailAdmin from "./components/admin/agent-detail";

export default function App() {
  return (
    <BrowserRouter>
      <ToastContainer />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="admin"
          element={
            <WithPrivateRoute>
              <AdminLayout />
            </WithPrivateRoute>
          }
        >
          <Route path="agents" element={<AgentList />} />
          <Route path="agent/:id" element={<AgentDetailAdmin />} />
          <Route path="add-agent" element={<AddAgent />} />
          <Route path="notifications" element={<Notifications />} />
          <Route path="notifications/:id" element={<Detail />} />
          <Route path="orders-list" element={<OrderListAdmin />} />
          <Route path="order/:id" element={<OrderDetailAdmin />} />
          <Route index element={<AdminHeader />} />
        </Route>
        <Route
          path="manager"
          element={
            <WithPrivateRoute>
              <ManagerLayout />
            </WithPrivateRoute>
          }
        >
          <Route path="agents" element={<AgentList />} />
          <Route path="agent/:id" element={<AgentDetail />} />
          <Route path="agent/:id/add-loan" element={<AddLoan />} />
          <Route path="agent/:id/add-settlement" element={<AddSettlement />} />
          <Route path="add-agent" element={<AddAgent />} />
          <Route path="orders-list" element={<OrderList />} />
          <Route path="order/:id" element={<OrderDetail />} />
          <Route path="orders/add-order" element={<AddOrder />} />
          <Route index element={<Header />} />
        </Route>
        <Route path="/login" element={<Login />} />
        <Route path="/chart" element={<BarChart />} />
        <Route path="/pie" element={<PieChart />} />
        <Route path="/new" element={<NewChart />} />

        <Route path="/head" element={<Head />} />
      </Routes>{" "}
    </BrowserRouter>
  );
}
